import { mapActions, mapState } from "vuex"
import dayjs from 'dayjs';
import { mapGetters } from "vuex/dist/vuex.common.js";

export default {
	components: {},
	filters: {
		formatDate(value) {
			return dayjs(value).format('DD.MM.YYYY HH:mm:ss');
		}
	},
	data() {
		return {
			selectedItem: null,
			columns: [
				{
					label: 'Лічильник',
					prop: 'meterNumber'
				},
				{
					label: 'Показник',
					prop: 'value'
				},
				{
					label: 'Доданий',
					prop: 'createdAt',
				},

			],
			limit: 10,
			offset: 0,
			currentPage: 1,
		}
	},
	computed: {
		...mapState({
			indicators: state => state.Indicators.indicators,
			total: (state) => state.Indicators.total,
			loading: state => state.Indicators.loading,
			refresh: state => state.Indicators.refresh,
		}),
		...mapGetters(['currentUserID', 'contractNumber'])
	},
	methods: {
		...mapActions(['getIndicatorsHistory', 'setRefresh']),
		indexMethod(index) {
			if (this.currentPage === 1) {
				return index;
			}
			return index + this.offset;
		},
	},
	watch: {
		currentPage(val) {
			this.offset = this.limit * val - this.limit;
			this.getIndicatorsHistory({ limit: this.limit, offset: this.offset, userId: this.currentUserID, contractNumber: this.contractNumber});
		},
		loading(val) {
			if (!val) {
				this.setRefresh(false);
			}
		},
		refresh(val) {
			if (val) {
				this.getIndicatorsHistory({ limit: this.limit, offset: this.offset, userId: this.currentUserID, contractNumber: this.contractNumber });
			}
		}
	},
	beforeMount() {
		this.getIndicatorsHistory({ limit: this.limit, offset: this.offset, userId: this.currentUserID, contractNumber: this.contractNumber });
	}
}